import React, { Component } from "react";
import { connect } from "react-redux";

//import { setSelectedUsers } from "Actions";
import { fetchTeam } from "Thunks";
import { setTeam } from "Actions";
import User from "./User";
import AvatarFetching from "./AvatarFetching";
import NotFound from "NotFound/NotFound";
//import _ from "i18n";

export class Users extends Component {
  state = {
    users: [],
    fillUsers: true
  };

  /*displayUser = (id, e) => {
    const order = e.currentTarget.nextSibling.value;
    console.log("before", this.state);

    this.setState({
      display: !this.state.display,
      users: !this.state.display
        ? this.state.users.splice(order - 1, 0, id)
        : this.state.users.filter(userId => userId !== id)
    });
    setTimeout(() => {
      console.log("after", this.state);
    }, 100);
  };*/
  /*constructor(props) {
    super(props);

    this.state = {
      currentPage: 0,
      requestsTokens: [],
      loadingMore: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fetching !== this.props.fetching) {
      this.setState({
        loadingMore: nextProps.fetching
      });
    }
  }

  loadMore() {
    const { role, searchWord, dispatch } = this.props;

    if (!this.props.fetching && !this.props.usersError) {
      this.setState({
        currentPage: this.state.currentPage + 1
      });
      dispatch(fetchUsers(this.state.currentPage, searchWord, role));
    }
  }*/

  /* componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchTeam()).then(() => {
      this.setState({
        currentPage: this.state.currentPage + 1
      });
    });
  }

  componentDidUpdate(prevProps) {
    const { role, searchWord, dispatch, usersError } = this.props;
    const { currentPage } = this.state;

    if (prevProps.role !== role || prevProps.searchWord !== searchWord) {
      this.setState({
        currentPage: 0
      });

      dispatch(fetchUsers(0, searchWord, role));
    }

    const classList = document.getElementById("setting-users").classList;
    if (usersError != null && usersError.code === 404 && currentPage === 0) {
      //classList.remove('row');
      //document.getElementById('setting-users').style.padding = 0;
    } else if (!classList.contains("grid-x")) {
      //classList.add('row');
      document.getElementById("setting-users").style.padding = "4rem 0";
    }
  }

  isSelected = user => {
    const { selectedIds } = this.props;

    return selectedIds.some(id => id === user.id);
  };

  toggleSelectUser = user => {
    const { dispatch, selectedIds } = this.props;

    if (this.isSelected(user)) {
      dispatch(setSelectedUsers(selectedIds.filter(id => id !== user.id)));
    } else {
      dispatch(setSelectedUsers([...selectedIds, user.id]));
    }
  };

  renderLoading() {
    const { loadingMore } = this.state;

    if (!loadingMore) {
      return null;
    }

    return <div className="infinite-scroll__loading">{_("Loading...")}</div>;
  }

  renderLoadMore() {
    const { loadingMore, fetching } = this.state;

    if (!loadingMore && !fetching) {
      return (
        <div className="infinite-scroll__loading">
          <button className="button" onClick={this.loadMore.bind(this)}>
            {_("Load more")}
          </button>
        </div>
      );
    }

    return null;
  }*/

  componentDidMount() {
    const { fetchTeam } = this.props;

    fetchTeam({ isPublic: false });
  }

  componentDidUpdate(prevProps) {
    const { fetched, users, setTeam, navCommunity } = this.props;
    if (fetched && users && users.length > 0 && this.state.fillUsers) {
      this.setState({ fillUsers: false });
      let cp = 1;
      if (
        navCommunity &&
        navCommunity.portalPreferences &&
        navCommunity.portalPreferences.team
      ) {
        const { team } = navCommunity.portalPreferences;
        let help = [];

        for (let i = 0; i < team.length; i++) {
          help.push({ id: team[i].id, order: i + 1 });
        }
        setTeam(help);
      } else {
        setTeam(users.map(user => ({ id: user.id, order: cp++ })));
      }
    }
  }

  render() {
    const { fetching, users, usersError, navCommunity } = this.props;
    //const { currentPage } = this.state;

    if (fetching /* && currentPage === 0*/) {
      return (
        <div className="setting-fetching grid-x">
          {[...Array(6).keys()].map(i => <AvatarFetching key={i} />)}
        </div>
      );
    }

    if (!users || users.length === 0) {
      return null;
    }
    if (
      usersError != null &&
      usersError.code === 404 /* && currentPage === 0*/
    ) {
      return (
        <div className="small-8 column grid-x">
          <NotFound
            mainClass="small-12 medium-12"
            txt="No User Could Be Found"
          />
        </div>
      );
    }

    let help = [];
    if (
      navCommunity &&
      navCommunity.portalPreferences &&
      navCommunity.portalPreferences.team
    ) {
      const { team } = navCommunity.portalPreferences;
      for (let i = 0; i < team.length; i++) {
        const current = users.filter(
          user => parseInt(user.id, 10) === parseInt(team[i].id, 10)
        );
        if (current && current.length > 0) {
          help.push({ ...current[0], title: team[i].title, display: true });
        }
      }
      if (help.length < users.length) {
        for (let i = 0; i < users.length; i++) {
          let found = false;
          for (let j = 0; j < help.length; j++) {
            if (help[j].id === users[i].id) {
              found = true;
            }
          }
          if (!found) {
            help.push({ ...users[i], title: null, display: false });
          }
        }
      }
    } else {
      for (let i = 0; i < users.length; i++) {
        help.push({ ...users[i], display: true });
      }
    }
    let i = 1;
    return (
      <div className="small-8 column grid-x">
        {help.map(user => (
          <User
            countUsers={users.length}
            {...user}
            key={`user-${user.id}`}
            order={i++}
            //onSelected={this.toggleSelectUser.bind(this, user)}
            //isSelected={this.isSelected(user)}
          />
        ))}
        {/*this.renderLoading()}
        {this.renderLoadMore()*/}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  users: state.users.items,
  fetched: state.users.fetched,
  fetching: state.users.fetching,
  usersError: state.users.error,
  navCommunity: state.auth.navCommunity
  //role: state.settings.filter.role,
  //searchWord: state.settings.filter.searchWord,
  //selectedIds: state.settings.selectedUsers
});

const mapDispatchToProps = dispatch => ({
  fetchTeam: params => dispatch(fetchTeam(params)),
  setTeam: users => dispatch(setTeam(users))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users);



// WEBPACK FOOTER //
// ./src/components/Settings/Users.js